document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', event => {
    document.querySelectorAll('.catalogue-finder .finder-drawer[open]').forEach(drawer => {
      if (!drawer.contains(event.target)) drawer.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const drawer = event.target.closest?.('.catalogue-finder .finder-drawer[open]');
    if (!drawer) return;
    event.preventDefault();
    drawer.open = false;
    drawer.querySelector(':scope > summary')?.focus();
  });

  const button = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');

  if (button && nav) {
    button.addEventListener('click', () => {
      const isOpen = nav.classList.toggle('is-open');
      button.setAttribute('aria-expanded', String(isOpen));
      button.textContent = isOpen ? 'Fermer' : 'Menu';
    });
    nav.addEventListener('click', event => {
      if (!event.target.closest('a')) return;
      nav.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
      button.textContent = 'Menu';
    });
  }

  if (button && nav) document.addEventListener('keydown', event => { if(event.key === 'Escape' && nav.classList.contains('is-open')) { nav.classList.remove('is-open'); button.setAttribute('aria-expanded','false'); button.textContent='Menu'; button.focus(); } });

  document.querySelectorAll('[data-add-to-quote]').forEach((quoteButton) => {
    quoteButton.addEventListener('click', async () => {
      const quantityInput = document.querySelector(quoteButton.dataset.quantityInput);
      const quantity = Number(quantityInput?.value || '1');
      if (!Number.isSafeInteger(quantity) || quantity < 1 || (quantityInput && !quantityInput.reportValidity())) return;
      quoteButton.disabled = true;
      quoteButton.textContent = 'Ajout en cours…';

      try {
        const response = await fetch(`${shopifyRoot()}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(quoteButton.dataset.variantId), quantity })
        });

        if (!response.ok) throw new Error('cart-add-failed');
        window.location.assign(quoteButton.dataset.quoteUrl);
      } catch (error) {
        quoteButton.disabled = false;
        quoteButton.textContent = 'Devis ou pro forma';
        window.alert('Le vin n’a pas pu être ajouté. Réessayez dans un instant.');
      }
    });
  });

  const quoteRequest = document.querySelector('[data-quote-request]');
  if (quoteRequest) hydrateQuoteRequest(quoteRequest);

  document.querySelectorAll('[data-reorder-order]').forEach(setupReorder);
  document.querySelectorAll('[data-address-toggle]').forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const target = document.getElementById(toggle.dataset.addressToggle);
      if (!target) return;
      target.hidden = !target.hidden;
      if (!target.hidden) target.querySelector('input, select, textarea')?.focus();
    });
  });

  const shippingSame = document.querySelector('[data-shipping-same]');
  const shippingFields = document.querySelector('[data-shipping-fields]');
  if (shippingSame && shippingFields) {
    const syncShippingFields = () => {
      shippingFields.hidden = shippingSame.checked;
      shippingFields.querySelectorAll('input').forEach((input) => { input.required = !shippingSame.checked; });
    };
    shippingSame.addEventListener('change', syncShippingFields);
    syncShippingFields();
  }

  const onboardingForm = document.querySelector('[data-professional-onboarding]');
  if (onboardingForm) {
    onboardingForm.addEventListener('submit', () => {
      const status = onboardingForm.querySelector('[data-onboarding-status]');
      if (status) status.textContent = 'Dossier en cours d’envoi…';
    });
  }

  const pickingCart = document.querySelector('[data-picking-cart]');
  if (pickingCart) setupPickingCart(pickingCart);

  document.querySelectorAll('form[data-lock-submit], form[action*="/cart/add"]').forEach((form) => {
    if(form.hasAttribute('data-quick-add')) return;
    form.addEventListener('submit', (event) => {
      if (form.dataset.submitting === 'true') {
        event.preventDefault();
        return;
      }
      form.dataset.submitting = 'true';
      form.setAttribute('aria-busy', 'true');
    });
  });
});

async function hydrateQuoteRequest(root) {
  const loading = root.querySelector('[data-quote-loading]');
  const empty = root.querySelector('[data-quote-empty]');
  const lines = root.querySelector('[data-quote-lines]');
  const summary = root.querySelector('[data-quote-summary]');
  const key = root.querySelector('[data-quote-key]');
  const submit = root.querySelector('[data-quote-submit]');
  const status = root.querySelector('[data-quote-status]');
  const form = root.querySelector('form');

  if (!lines || !summary || !key) return;
  const documentOptions = [...root.querySelectorAll('[data-document-kind]')];
  const requestedKind = new URLSearchParams(window.location.search).get('document') === 'proforma' ? 'Pro forma' : 'Devis';
  documentOptions.forEach(input => { input.checked = input.value === requestedKind; });
  const refreshDocument = () => {
    const kind = documentOptions.find(input => input.checked)?.value || 'Devis';
    root.querySelector('[data-quote-subject]').value = `Demande de ${kind.toLowerCase()} professionnel`;
    if (submit) submit.textContent = kind === 'Pro forma' ? 'Demander ma pro forma' : 'Demander mon devis';
  };
  documentOptions.forEach(input => input.addEventListener('change', refreshDocument));
  refreshDocument();

  try {
    const response = await fetch(`${shopifyRoot()}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('cart-fetch-failed');
    const cart = await response.json();
    loading.hidden = true;

    const wines = cart.items.filter(item => String(item.variant_id) !== root.dataset.feeVariant);
    if (!wines.length) {
      empty.hidden = false;
      if (submit) submit.disabled = true;
      return;
    }

    const list = document.createElement('ul');
    list.className = 'quote-selection__lines';
    wines.forEach((item) => {
      const line = document.createElement('li');
      const name = document.createElement('span');
      const amount = document.createElement('strong');
      name.textContent = [item.product_title, item.variant_title !== 'Default Title' ? item.variant_title : ''].filter(Boolean).join(' — ');
      amount.textContent = `${item.quantity} ×`;
      line.append(name, amount);
      list.append(line);
    });
    lines.replaceChildren(list);

    summary.value = quoteCartSummary(cart);
    key.value = `EFF-${crypto.randomUUID()}`;
    if (submit) submit.disabled = false;
  } catch (error) {
    loading.textContent = 'Impossible de charger la sélection. Rechargez la page.';
    if (submit) submit.disabled = true;
  }

  if (form && submit) {
    form.addEventListener('submit', () => {
      submit.disabled = true;
      submit.textContent = 'Envoi en cours…';
      if (status) status.textContent = 'Votre demande est en cours d’envoi. Ne fermez pas cette page.';
    });
  }
}

function shopifyRoot() {
  return window.Shopify?.routes?.root || '/';
}

function setupReorder(button) {
  button.addEventListener('click', async () => {
    const scope = button.closest('[data-reorder-scope]');
    const status = scope?.querySelector('[data-reorder-status]');
    const items = [...(scope?.querySelectorAll('[data-reorder-item]') || [])].map((item) => ({
      id: Number(item.dataset.variantId),
      quantity: Math.max(1, Number.parseInt(item.dataset.quantity || '1', 10))
    }));

    if (!items.length) {
      if (status) status.textContent = 'Aucune référence encore disponible dans cette commande.';
      return;
    }

    button.disabled = true;
    if (status) status.textContent = 'Ajout au panier…';
    try {
      const response = await fetch(`${shopifyRoot()}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!response.ok) throw new Error('reorder-failed');
      window.location.assign(`${shopifyRoot()}cart`);
    } catch (error) {
      button.disabled = false;
      if (status) status.textContent = 'Certaines références ne peuvent pas être ajoutées. Réessayez ou contactez-nous.';
    }
  });
}

function pickingPlan(lines, enabled = true) {
  const groups = new Map();
  const errors = [];
  for (const line of lines) {
    if (line.fee) continue;
    const quantity = Number(line.quantity);
    const pack = Number(line.casePack);
    if (String(line.quantity).trim() === '' || !Number.isSafeInteger(quantity) || quantity < 0) {
      errors.push('Indiquez des quantités entières, égales ou supérieures à zéro.');
      continue;
    }
    if (!line.variantId || !Number.isSafeInteger(pack) || pack < 1) {
      errors.push('Le colisage de cette sélection doit être vérifié.');
      continue;
    }
    const id = String(line.variantId);
    const group = groups.get(id) || { quantity: 0, pack };
    if (group.pack !== pack) errors.push('Deux lignes de la même référence ont un colisage différent. Rechargez le panier.');
    group.quantity += quantity;
    groups.set(id, group);
  }
  return {
    errors: [...new Set(errors)],
    pickingBottles: enabled ? [...groups.values()].reduce((sum, group) => sum + group.quantity % group.pack, 0) : 0,
    quantity: [...groups.values()].reduce((sum, group) => sum + group.quantity, 0),
  };
}

function quoteCartSummary(cart) {
  const money = cents => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: cart.currency }).format(cents / 100);
  const bottles = cart.items.filter(item => item.properties?._effervessens_picking_fee !== 'true').reduce((n, item) => n + item.quantity, 0);
  const shipping = bottles > 0 && bottles < 78 ? 3500 : 0;
  return [
    'Sélection indicative à vérifier par Camilia — aucun paiement ni réservation.',
    ...cart.items.map(item => `${item.quantity} × ${item.product_title}${item.variant_title && item.variant_title !== 'Default Title' ? ` — ${item.variant_title}` : ''} | Réf. ${item.sku || 'à confirmer'} | Variante ${item.variant_id} | Total ligne ${money(item.final_line_price)}`),
    `Sous-total des vins : ${money(cart.total_price)} ${cart.taxes_included ? 'TTC' : 'HT'}.`,
    `Livraison par le logisticien : ${money(shipping)} HT pour ${bottles} bouteilles. Franco dès 78 bouteilles, toutes cuvées confondues.`,
    cart.taxes_included ? 'Total TTC à confirmer sur le document.' : `Total indicatif, livraison comprise : ${money(cart.total_price + shipping)} HT. TVA en sus.`,
    'Les quantités, prix, remises et coordonnées doivent être contrôlés avant émission du document.',
  ].join('\n');
}

async function cartRequest(path, body) {
  const response = await fetch(`${shopifyRoot()}${path}`, {
    method: body ? 'POST' : 'GET',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    ...(body ? { body: JSON.stringify(body) } : {}),
    cache: 'no-store',
  });
  if (!response.ok) throw new Error('cart-request-failed');
  return response.json();
}

function cartWineSignature(items, feeVariantId) {
  const grouped = new Map();
  items.filter(item => String(item.variant_id) !== String(feeVariantId)).forEach(item => {
    const identity = `${item.variant_id}|${JSON.stringify(Object.entries(item.properties || {}).sort())}|${item.selling_plan_allocation?.selling_plan?.id || ''}`;
    grouped.set(identity, (grouped.get(identity) || 0) + item.quantity);
  });
  return JSON.stringify([...grouped.entries()].filter(([, quantity]) => quantity > 0).sort());
}

async function savePreparedCart(lines, feeVariantId, enabled) {
  const result = pickingPlan(lines, enabled);
  if (result.errors.length || !result.quantity) throw new Error('invalid-cart');
  if (result.pickingBottles > 0 && !feeVariantId) throw new Error('fee-not-configured');
  const original = await cartRequest('cart.js');
  const wines = original.items.filter(item => String(item.variant_id) !== String(feeVariantId));
  const wanted = lines.filter(line => !line.fee);
  if (wines.length !== wanted.length || wines.some(item => !wanted.some(line => line.key === item.key && Number(line.originalQuantity) === item.quantity))) {
    throw new Error('cart-changed');
  }
  const expected = wines.map(item => ({ ...item, quantity: Number(wanted.find(line => line.key === item.key).quantity) }));
  const signature = cartWineSignature(expected, feeVariantId);
  let cart = await cartRequest('cart/update.js', { updates: Object.fromEntries(wanted.map(line => [line.key, Number(line.quantity)])) });
  if (cartWineSignature(cart.items, feeVariantId) !== signature) throw new Error('quantity-adjusted');
  const feeLines = cart.items.filter(item => String(item.variant_id) === String(feeVariantId));
  if (feeLines.length) {
    cart = await cartRequest('cart/update.js', { updates: Object.fromEntries(feeLines.map((item, index) => [item.key, index === 0 ? result.pickingBottles : 0])) });
  } else if (result.pickingBottles > 0) {
    await cartRequest('cart/add.js', { id: Number(feeVariantId), quantity: result.pickingBottles, properties: { _effervessens_picking_fee: 'true' } });
  }
  await cartRequest('cart/update.js', { attributes: { 'Mode de préparation': !enabled ? 'À confirmer' : result.pickingBottles ? 'Picking automatique' : 'Cartons complets' } });
  cart = await cartRequest('cart.js');
  const fees = cart.items.filter(item => String(item.variant_id) === String(feeVariantId));
  if (cartWineSignature(cart.items, feeVariantId) !== signature || fees.reduce((sum, item) => sum + item.quantity, 0) !== result.pickingBottles || fees.length > 1) {
    throw new Error('cart-changed');
  }
  return cart;
}

function setupPickingCart(form) {
  const status = form.querySelector('[data-cart-status]');
  const pickingStatus = form.querySelector('[data-picking-status]');
  const feeVariantId = form.dataset.pickingFeeVariant;
  const enabled = form.dataset.pickingEnabled === 'true';
  let busy = false;
  const readLines = () => [...form.querySelectorAll('[data-cart-line]')].map(line => ({
    key: line.dataset.lineKey,
    variantId: line.dataset.variantId,
    originalQuantity: line.dataset.originalQuantity,
    quantity: line.querySelector('[data-cart-quantity]')?.value,
    casePack: line.dataset.casePack,
    fee: line.dataset.feeLine === 'true',
  }));
  const validate = () => {
    const result = pickingPlan(readLines(), enabled);
    const shippingSummary = form.querySelector('[data-shipping-summary]');
    if (shippingSummary) shippingSummary.textContent = result.errors.length
      ? 'Corrigez les quantités pour calculer la livraison.'
      : result.quantity >= 78 ? `${result.quantity} bouteilles : livraison offerte par notre logisticien.`
      : `${result.quantity} bouteille${result.quantity > 1 ? 's' : ''} : livraison 35 € HT. Encore ${78 - result.quantity} pour le franco, toutes cuvées confondues.`;
    if (result.pickingBottles > 0 && !feeVariantId) result.errors.push('Les frais de préparation doivent être configurés avant de continuer.');
    if (pickingStatus) {
      pickingStatus.textContent = result.errors.length ? result.errors.join(' ') : result.pickingBottles
        ? `${result.pickingBottles} bouteille${result.pickingBottles > 1 ? 's' : ''} hors carton complet : frais de préparation recalculés avant de continuer.`
        : 'Cartons complets : aucun supplément de préparation.';
      pickingStatus.classList.toggle('is-error', result.errors.length > 0);
    }
    return result;
  };
  form.querySelectorAll('[data-cart-quantity]').forEach(input => input.addEventListener('input', validate));
  validate();
  const proceed = async destination => {
    if (busy) return;
    const result = validate();
    if (result.errors.length || !result.quantity || !form.reportValidity()) {
      if (status) status.textContent = result.errors.join(' ') || 'Ajoutez au moins une bouteille avant de continuer.';
      return;
    }
    busy = true;
    const lines = readLines();
    const controls = [...form.querySelectorAll('button, input')].filter(control => !control.disabled);
    controls.forEach(control => { control.disabled = true; });
    form.setAttribute('aria-busy', 'true');
    if (status) status.textContent = 'Enregistrement des quantités…';
    try {
      await savePreparedCart(lines, feeVariantId, enabled);
      window.location.assign(destination);
    } catch (error) {
      if (status) status.textContent = 'Le panier a changé ou n’a pas pu être enregistré. Rechargez-le pour vérifier les quantités avant de continuer.';
      controls.forEach(control => { control.disabled = false; });
      form.removeAttribute('aria-busy');
      busy = false;
    }
  };
  form.querySelector('[data-cart-checkout]')?.addEventListener('click', () => proceed(`${shopifyRoot()}checkout`));
  form.querySelectorAll('[data-cart-document]').forEach(button => button.addEventListener('click', () => proceed(`${shopifyRoot()}pages/demande-de-devis?view=demande-de-devis&document=${button.dataset.cartDocument}`)));
}

function showProductImageFallback(image) {
  const visual = image.closest('[data-product-visual]');
  const message = visual?.querySelector('.product-visual__waiting');
  if (!message) return;
  image.hidden = true;
  message.hidden = false;
}
document.addEventListener('error', event => {
  if (event.target instanceof HTMLImageElement) showProductImageFallback(event.target);
}, true);
function checkProductImages() {
  document.querySelectorAll('[data-product-visual] img').forEach(image => {
    if (image.complete && image.naturalWidth === 0) showProductImageFallback(image);
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', checkProductImages);
else checkProductImages();
